let languages = [
  'en',
  'en-US',
  'en-us',
  'en-GB',
  'en-gb',
  'en-AU',
  'en-au',
  'en-BZ',
  'en-bz',
  'en-IE',
  'en-ie',
  'en-JM',
  'en-jm',
  'en-CA',
  'en-ca',
  'en-NZ',
  'en-nz',
  'en-PH',
  'en-ph',
  'en-ZW',
  'en-zw',
  'en-ZA',
  'en-za',
  'en-TT',
  'en-tt',
  'de',
  'de-DE',
  'de-de',
  'de-CH',
  'de-ch',
  'de-AT',
  'de-at',
  'de-LI',
  'de-li',
  'de-LU',
  'de-lu'
]
import cookie from 'cookie'
import acceptLanguage from 'accept-language'
acceptLanguage.languages(languages)
let loadNaviAndFooter = ({ store }) => {
  store.dispatch('getNavigation')
  store.dispatch('getFooter')
}
let setPersistantState = ({ req, store }) => {
  let defaultPathLanguages = []
  let currentPath = ''
  if (process.server && req.headers) {
    currentPath = req.originalUrl.split('?')[0]
  } else if (process.client && window) {
    currentPath = window.location.pathname
  }
  store.getters.languagePaths.forEach((item) => {
    store.getters.possibleLanguages.forEach((language) => {
      if (item && item[language] && item[language].path == currentPath) {
        defaultPathLanguages.push(language)
      }
    })
  })
  if (defaultPathLanguages.length == 1) {
    store.commit('setLanguage', { language: defaultPathLanguages[0] })
    loadNaviAndFooter({ store: store })
  } else {
    let cookies = process.client ? document.cookie : ''
    cookies = process.server ? req.headers.cookie : cookies
    let savedCookies = cookie.parse(cookies || '')
    let savedLanguage = savedCookies['language']
    if (savedLanguage) {
      store.commit('setLanguage', { language: savedLanguage })
      loadNaviAndFooter({ store: store })
    } else {
      let browserLanguages = process.client
        ? navigator.language
        : req.headers['accept-language']
      const acceptedLanguage = acceptLanguage
        .get(browserLanguages)
        .split('-')[0]
      if (!acceptedLanguage) {
        store.commit('setLanguage', { language: defaultPathLanguages[0] })
        loadNaviAndFooter({ store: store })
      } else {
        store.commit('setLanguage', { language: acceptedLanguage })
        loadNaviAndFooter({ store: store })
      }
    }
  }
}
export default function ({ store, route, req }) {
  // If the user is not authenticated
  if (store && route && store.getters.languagePaths) {
    let paths = {}
    store.getters.languagePaths.forEach((item) => {
      Object.keys(item).forEach((language) => {
        if (!paths[language]) {
          paths[language] = []
        }
        paths[language].push(item[language].path)
      })
    })
    let possibleLanguages = Object.keys(paths).filter((language) => {
      return paths[language].includes(route.path)
    })
    if (
      possibleLanguages.length > 0 &&
      !possibleLanguages.includes(store.getters.language)
    ) {
      setPersistantState({ req: req, store: store })
      // store.commit('setLanguage', { language: possibleLanguages[0] })
      loadNaviAndFooter({ store: store })
    }
  }
}
